import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";

(function ($, Drupal, drupalSettings) {
  "use strict";

  $('body').on('click', '.saipem-event-tab-item--title', function(e){
    e.preventDefault();

    let $parent = $(this).parents('.saipem-event-tab-item');
    $parent.toggleClass('active');

  });

})(jQuery, Drupal, drupalSettings);